export default __webpack_public_path__ + "static/media/aveOloom.c2da4d5e.jpeg";